export default "__VITE_ASSET__3e6afbba__"